<script>
  import { hooksStore } from "../../stores/hooks.store";
  import { tempStore } from "../../stores/temp.store";

  import { config } from "./config";

  import { dropzoneInit, tempFiles, ulozit } from "./formular.func";
  import { zrusit } from "./rozkopavky.func";

  import { Draw } from "../Base/Controls/mapboxDraw";
  import { viditelnostTabu } from "../Base/sidebarLeft.func";
  import { vratZoznamSelectu } from "../../api/selects";
  import { getMap, pointTo } from "../../helpers/map";

  import { onMount, onDestroy, afterUpdate } from "svelte";

  import { DateInput } from "date-picker-svelte";
  import get from "get-value";
  import find from "lodash/find";

  import "dropzone/dist/dropzone.css";

  const port = location.port || (location.protocol === "https:" ? "443" : "80");

  export let kodMenu;
  let dropzones = [];
  let tlacitkoOdoslat = "Uložiť";
  let messages = { errors: [], successes: [] };
  export let rozkopavkaId;
  export let sourceId;
  let layer;
  let kreslenia = [];
  let kresleniaKRozkopavke = [];
  export let formularIsOpen;
  let nazov;
  let form;
  let popup;
  let locale = {
    weekdays: ["Ne", "Po", "Ut", "St", "Št", "Pi", "So"],
    months: [
      "Január",
      "Február",
      "Marec",
      "Apríl",
      "Máj",
      "Jún",
      "Júl",
      "August",
      "September",
      "Október",
      "November",
      "December",
    ],
  };

  let formData = {
    datum_zadania: null,
    datum_realizacie: null,
    datum_konca_zaruky: null,
    datum_prebratia: null,
    nazov_ziadatela: null,
    plocha_rozkopavky: null,
    ulica: null,
    dovod_rozkopavky: null,
    druh_rozkopavky: null,
    vlastnik_objektu: null,
    cislo_rz: null,
    cislo_rz_files: null,
    poznamka: null,
    poznamka_files: null,
    fotografia_pred_files: null,
    fotografia_po_files: null,
  };

  let ulice = [];
  onMount(async () => {
    ulice = await vratZoznamSelectu("ulice");

    for (const name in tempFiles) {
      dropzones.push(dropzoneInit(name.slice(0, -6), formData));
    }
  });

  const unsubscribeTemp = tempStore.subscribe((value) => {
    if (get(value, "kreslenia", false)) {
      kreslenia = get(value, "kreslenia.features") || [];
      kresleniaKRozkopavke = get(value, `kreslenia_${config.moduleName}`) || {};

      kreslenia.map((k) => {
        if (rozkopavkaId && get(kresleniaKRozkopavke, rozkopavkaId)) {
          k.checked = kresleniaKRozkopavke[rozkopavkaId].includes(k.id);
          k.priradene = kresleniaKRozkopavke[rozkopavkaId].includes(k.id);
        }
      });
      upravInputKreslenia();
    }
  });

  hooksStore.addAction(
    `${config.moduleName}_skryFormular`,
    `${config.moduleName}_Formular.svelte`,
    () => {
      formularIsOpen = false;
    }
  );

  hooksStore.addAction(
    `${config.moduleName}_zobrazFormular`,
    `${config.moduleName}_Formular.svelte`,
    zobrazFormularNaRozkopavku
  );

  hooksStore.addFilter(
    `${config.moduleName}_formMessages`,
    `${config.moduleName}_Formular.svelte`,
    formMessages
  );

  hooksStore.addFilter(
    `${config.moduleName}_formReset`,
    `${config.moduleName}_formular.svelte`,
    formReset
  );
  hooksStore.addFilter(
    `${config.moduleName}_aktualizujInput`,
    `${config.moduleName}_formular.svelte`,
    aktualizujInput
  );

  hooksStore.addFilter(
    `${config.moduleName}_aktualizujSubmit`,
    `${config.moduleName}_formular.svelte`,
    aktualizujSubmit
  );

  function formMessages(msgs) {
    messages = msgs;
  }

  function aktualizujSubmit(string) {
    tlacitkoOdoslat = string;
  }

  function formReset() {
    for (const input in formData) {
      if (input.indexOf("_files") !== -1) {
        formData[input].value = "";
      } else if (input.indexOf("datum_") !== -1) {
        formData[input] = null;
      } else {
        formData[input] = "";
      }
    }

    hooksStore.applyFilters(`${config.moduleName}_formMessages`, {
      errors: [],
      successes: [],
    });
    dropzones.forEach((dz) => {
      dz.dz.removeAllFiles();
    });
  }

  function aktualizujInput(input, values) {
    if (input) {
      input.value = values.map((value) => value.id).toString();
    }
  }

  function zvyrazni(kreslenieId, highlight = true) {
    const map = getMap();
    let highlightedFeatures = [];
    map
      .querySourceFeatures("mapbox-gl-draw-hot", {
        filter: ["==", "id", kreslenieId],
      })
      .map((k) => {
        if (k.properties && !highlightedFeatures.includes(k.properties.id)) {
          highlightedFeatures.push(k.properties.id);
        }
      });
    map
      .querySourceFeatures("mapbox-gl-draw-cold", {
        filter: ["==", "id", kreslenieId],
      })
      .map((k) => {
        if (k.properties && !highlightedFeatures.includes(k.properties.id)) {
          highlightedFeatures.push(k.properties.id);
        }
      });

    highlightedFeatures.forEach(function (id) {
      Draw.setFeatureProperty(id, "hover", highlight ? "true" : "false");
      Draw.add(Draw.get(id));
    });
  }

  function doPointTo(kreslenieId) {
    Draw.getAll().features.map((d) => {
      if (d.id === kreslenieId) {
        pointTo({
          type: "FeatureCollection",
          features: [d],
        });
      }
    });
  }

  function upravInputKreslenia() {
    const zakliknuteKreslenia = document.querySelectorAll(
      `.${config.moduleName}-formular .aktivneKreslenia input[name="kreslenia"]:checked`
    );

    // if (zakliknuteKreslenia.length) {
    let featureCollection = {
      type: "FeatureCollection",
      features: [],
    };

    const features = [].map.call(zakliknuteKreslenia, (el) => {
      return find(kreslenia, (k) => k.id === el.value);
    });
    if (features.length) {
      featureCollection.features = features;
      layer = JSON.stringify(featureCollection);
    } else {
      layer = "";
    }
    // }
  }

  function zobrazFormularNaRozkopavku(data) {
    viditelnostTabu(kodMenu, true);
    hooksStore.doAction(
      `${config.moduleName}_zrusitForrmular`,
      data.sourceId,
      data.rozkopavka_id
    );
    formularIsOpen = true;
    popup = data.popup || null;

    if (data.props) {
      for (const fdata in formData) {
        if (fdata.indexOf("datum_") !== -1) {
          var euro_date = data.props[fdata];
          if (euro_date) {
            euro_date = euro_date.split(".");
            var us_date = euro_date.reverse().join("-");
          }
          formData[fdata] = data.props[fdata] ? new Date(us_date) : null;
        } else if (fdata.indexOf("_files") !== -1) {
          formData[fdata].value = data.props[fdata];
          if (data.props[fdata]) {
            const ids = data.props[fdata].split(",");
            const dz = dropzones.find((d) => d.name === fdata);
            tempFiles[`${fdata}_array`] = [];
            ids.forEach((id) => {
              const f = data.props["files"].find((e) => e.id == id);
              if (f) {
                let resizeThumbnail = true;
                if (
                  !["jpg", "jpeg", "png", "gif"].includes(
                    f.sys_name.split(".").pop()
                  )
                ) {
                  resizeThumbnail = false;
                }
                f.imageUrl = `${__myapp.env.API_URL}:${port}/${__myapp.env.API_PATH}/api/v1/smartmap/file/${config.moduleName}/${f.sys_name}`;
                dz.dz.files.push(f);
                dz.dz.displayExistingFile(
                  f,
                  `${__myapp.env.API_URL}:${port}/${__myapp.env.API_PATH}/api/v1/smartmap/file/${config.moduleName}/${f.sys_name}`,
                  null,
                  null,
                  resizeThumbnail
                );
                tempFiles[`${fdata}_array`].push({
                  id: f.id,
                  filename: f.file_name,
                });
              }
            });
          } else {
          }
        } else {
          formData[fdata] = data.props[fdata];
        }
      }
      nazov = data.props._nazov || null;
    }
    layer = data.geojson || null;
    rozkopavkaId = data.rozkopavka_id || null;
    sourceId = data.sourceId || null;
    popup = data.popup || null;
  }

  onDestroy(unsubscribeTemp);
  afterUpdate(() => {
    upravInputKreslenia();
  });
</script>

<div class="{config.moduleName}-formular formular" class:formularIsOpen>
  <!-- <h6 class="sidebar__heading">Formulár</h6> -->
  <h6 class="sidebar__heading">{nazov || config.texts.formTitle}</h6>
  <form on:submit|preventDefault={(e) => ulozit(popup, form)} bind:this={form}>
    <div class="flex">
      <div class="input-group datepicker">
        <label class="input__label" for="datum-zadania">Dátum zadania</label>
        <DateInput
          bind:value={formData.datum_zadania}
          format="dd.MM.yyyy"
          {locale}
          max={new Date(2040, 11, 31, 23, 59, 59, 999)}
          min={new Date(2023, 0, 1, 0, 0, 0, 0)}
          placeholder=""
          closeOnSelection={true}
        />
        <input
          type="hidden"
          name="datum_zadania"
          bind:value={formData.datum_zadania}
        />
      </div>
      <div class="input-group datepicker">
        <label class="input__label" for="datum-realizacie"
          >Dátum realizácie</label
        >
        <DateInput
          bind:value={formData.datum_realizacie}
          format="dd.MM.yyyy"
          {locale}
          max={new Date(2040, 11, 31, 23, 59, 59, 999)}
          min={new Date(2023, 0, 1, 0, 0, 0, 0)}
          placeholder=""
          closeOnSelection={true}
        />
        <input
          type="hidden"
          name="datum_realizacie"
          bind:value={formData.datum_realizacie}
        />
      </div>
      <div class="input-group datepicker">
        <label class="input__label" for="datum-prebratie"
          >Ukončenie práce (prevzatie)</label
        >
        <DateInput
          bind:value={formData.datum_prebratia}
          format="dd.MM.yyyy"
          {locale}
          max={new Date(2040, 11, 31, 23, 59, 59, 999)}
          min={new Date(2023, 0, 1, 0, 0, 0, 0)}
          placeholder=""
          closeOnSelection={true}
        />
        <input
          type="hidden"
          name="datum_prebratia"
          bind:value={formData.datum_prebratia}
        />
      </div>
      <div class="input-group datepicker">
        <label class="input__label" for="datum-konca-zaruky"
          >Dátum konca záruky</label
        >
        <DateInput
          bind:value={formData.datum_konca_zaruky}
          format="dd.MM.yyyy"
          {locale}
          max={new Date(2040, 11, 31, 23, 59, 59, 999)}
          placeholder=""
          closeOnSelection={true}
        />
        <input
          type="hidden"
          name="datum_konca_zaruky"
          bind:value={formData.datum_konca_zaruky}
        />
      </div>
    </div>

    <div class="input-group">
      <label class="input__label" for="miesto_rozkopavky"
        >Miesto rozkopávky</label
      >
      <select
        name="miesto_rozkopavky"
        class="input input-margin"
        id="miesto_rozkopavky"
        bind:value={formData.miesto_rozkopavky}
      >
        <option />
        <option value="komunikacia-asfalt">Komunikácia-asfalt</option>
        <option value="komunikacia-beton">Komunikácia-betón</option>
        <option value="komunikacia-dlazba">Komunikácia-dlažba</option>
        <option value="komunikacia-ine">Komunikácia-iné</option>
        <option value="verejna-zelen">Verejná zeleň</option>
      </select>
    </div>

    <div class="input-group">
      <label class="input__label" for="ulica">Ulica *</label>
      <select
        name="ulica_id"
        class="input input-margin"
        id="ulica"
        bind:value={formData.ulica_id}
      >
        {#each ulice as ulica}
          <option value={ulica.id}>{ulica.nazov}</option>
        {/each}
      </select>
    </div>

    <div class="flex">
      <div class="input-group">
        <label class="input__label" for="plocha-rozkopavky"
          >Plocha rozkopávky *</label
        >
        <input
          type="text"
          id="plocha-rozkopavky"
          class="input input-margin"
          name="plocha_rozkopavky"
          bind:value={formData.plocha_rozkopavky}
        />
      </div>
      <div class="input-group">
        <label class="input__label" for="nazov-ziadatela"
          >Názov žiadateľa
        </label>
        <input
          type="text"
          id="nazov-ziadatela"
          class="input input-margin"
          name="nazov_ziadatela"
          bind:value={formData.nazov_ziadatela}
        />
      </div>
      <div class="input-group">
        <label class="input__label" for="vlastnik-objektu"
          >Vlastník objektu
        </label>
        <input
          type="text"
          id="vlastnik-objektu"
          class="input input-margin"
          name="vlastnik_objektu"
          bind:value={formData.vlastnik_objektu}
        />
      </div>
    </div>

    <div class="flex">
      <div class="input-group">
        <label class="input__label" for="druh_rozkopavky"
          >Druh rozkopávky *</label
        >
        <select
          name="druh_rozkopavky"
          class="input input-margin"
          id="druh_rozkopavky"
          bind:value={formData.druh_rozkopavky}
        >
          <option value="planovana">Plánovaná</option>
          <option value="neplanovaná">Neplánovaná - porucha</option>
        </select>
      </div>
      <div class="input-group">
        <label class="input__label" for="dovod_rozkopavky"
          >Dôvod rozkopávky *</label
        >
        <select
          name="dovod_rozkopavky"
          class="input input-margin"
          id="dovod_rozkopavky"
          bind:value={formData.dovod_rozkopavky}
        >
          <option value="plyn">Plyn</option>
          <option value="voda">Voda</option>
          <option value="teplo">Teplo</option>
          <option value="elektrina">Elektrina</option>
          <option value="vytlk">Výtlk</option>
          <option value="ine">Iné</option>
        </select>
      </div>
    </div>

    <div class="dz-upload">
      <div class="input-group">
        <label class="input__label" for="cislo-rz">Číslo RZ</label>
        <input
          type="text"
          id="cislo-rz"
          class="input input-margin"
          name="cislo_rz"
          bind:value={formData.cislo_rz}
        />
        <input
          type="hidden"
          name="cislo_rz_files"
          bind:this={formData.cislo_rz_files}
        />
      </div>
      <div id="{config.moduleName}_cislo_rz_dz" class="dropzone">
        <div class="previews" />
      </div>
    </div>

    <div class="dz-upload">
      <div class="input-group">
        <label class="input__label" for="poznamka">Poznámka</label>
        <textarea
          name="poznamka"
          id="poznamka"
          class="input input-margin"
          cols="30"
          rows="10"
          bind:value={formData.poznamka}
        />
        <input
          type="hidden"
          name="poznamka_files"
          bind:this={formData.poznamka_files}
        />
      </div>
      <div id="{config.moduleName}_poznamka_dz" class="dropzone">
        <div class="previews" />
      </div>
    </div>

    <div class="dz-upload">
      <div class="input-group">
        <label class="input__label" for="fotografia-pred">Fotografia pred</label
        >
        <input
          type="hidden"
          name="fotografia_pred_files"
          bind:this={formData.fotografia_pred_files}
        />
      </div>
      <div id="{config.moduleName}_fotografia_pred_dz" class="dropzone">
        <div class="previews" />
      </div>
    </div>

    <div class="dz-upload">
      <div class="input-group">
        <label class="input__label" for="fotografia-po">Fotografia po</label>
        <input
          type="hidden"
          name="fotografia_po_files"
          bind:this={formData.fotografia_po_files}
        />
      </div>
      <div id="{config.moduleName}_fotografia_po_dz" class="dropzone">
        <div class="previews" />
      </div>
    </div>

    <div class="aktivneKreslenia">
      <h7 class="sidebar__heading">Aktívne kreslenia</h7>
      {#each kreslenia as kreslenie, i}
        {@const typeName =
          get(kreslenie, "geometry.type") === "LineString"
            ? "Línia"
            : get(kreslenie, "geometry.type") === "Polygon"
            ? "Polygón"
            : get(kreslenie, "geometry.type") === "Point"
            ? "Bod"
            : ""}
        <div
          class="input-group"
          on:mouseenter={() => zvyrazni(kreslenie.id)}
          on:mouseleave={() => zvyrazni(kreslenie.id, false)}
        >
          <div class="header">
            <label class="checkbox">
              <input
                name="kreslenia"
                type="checkbox"
                id="kreslenie_rozkopavka_{kreslenie.id}"
                value={kreslenie.id}
                on:change={() => upravInputKreslenia()}
                bind:checked={kreslenie.checked}
              />
              <label for="kreslenie_rozkopavka_{kreslenie.id}">{typeName}</label
              >
            </label>
            <span class="tlacitka">
              <span on:click={() => doPointTo(kreslenie.id)}>
                <!-- JSON icon location start -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon"
                  viewBox="0 0 370.854 511.999"
                  fill="currentColor"
                >
                  <g transform="translate(-70.573)">
                    <g>
                      <path
                        d="M256,0C153.755,0,70.573,83.182,70.573,185.426c0,126.888,165.939,313.167,173,321.035a16.7,16.7,0,0,0,24.846,0c7.065-7.868,173-194.147,173-321.035C441.425,83.182,358.244,0,256,0Zm0,278.719a93.292,93.292,0,1,1,93.291-93.292A93.4,93.4,0,0,1,256,278.719Z"
                      />
                    </g>
                  </g>
                </svg>
                <!-- JSON icon location end -->
              </span>
            </span>
          </div>
          <div class="sys-data">{@html kreslenie.properties.sysData || ""}</div>
          <div class="priradenie" class:priradene={kreslenie.priradene}>
            {kreslenie.priradene
              ? "Objekt k editovanej poznámke"
              : "Nový objekt"}
          </div>
        </div>
      {/each}
    </div>

    <div class="input-group input-group--cta">
      <input type="hidden" name="layers" bind:value={layer} />
      <input type="hidden" name="id" bind:value={rozkopavkaId} />
      <input type="hidden" name="sourceId" bind:value={sourceId} />
      <div id="response">
        {#if messages.errors}
          {#each messages.errors as error}
            <div class="error">{error}</div>
          {/each}
        {/if}
        {#if messages.successes}
          {#each messages.successes as success}
            <div class="success">{success}</div>
          {/each}
        {/if}
      </div>
      <input
        type="submit"
        class="btn btn--block btn--mb"
        value={tlacitkoOdoslat}
      />
      <button
        type="submit"
        class="btn btn--secondary btn--block"
        on:click|preventDefault={(e) => zrusit(sourceId, rozkopavkaId)}
        >Zrušiť</button
      >
    </div>
  </form>
</div>

<style lang="scss">
  .aktivneKreslenia .input-group {
    padding-bottom: 10px;
    border-bottom: 1px solid #dbdbdb;
  }
  .formular {
    display: none;
    &.formularIsOpen {
      display: block;
    }
  }
  #response {
    margin-bottom: 20px;
    text-align: center;
    font-size: 17px;
    .error {
      color: #c24141;
    }
    .success {
      color: #008000;
    }
  }

  .sys-data {
    padding-left: 2rem;
    font-size: var(--text-xs);
  }

  .aktivneKreslenia {
    .header {
      height: auto;
      background: none;
      margin: 10px 0 0;
      padding: 0;
      display: flex;
      justify-content: space-between;

      &::before {
        display: none;
      }

      .tlacitka {
        & > span {
          cursor: pointer;
        }
      }
    }

    .priradenie {
      padding-left: 2rem;
      font-size: var(--text-xs);
      color: red;
      opacity: 0.4;

      &.priradene {
        color: green;
      }
    }
  }
  .flex {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }
  .dz-upload {
    margin-bottom: 1.5rem;
  }
</style>
